module.exports = __webpack_public_path__ + "e80369f805f6f2c39daea2ac3ee4238b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/beers/images/exclusive_red.png
// module id = G5AZ
// module chunks = 0